export default __webpack_public_path__ + "static/media/1957.260cd541.png";